import tableMain from "./tableMain";
import main from "themes/main";

import merge from "lodash/merge";

const mergedThemes = merge(tableMain, main);

export { mergedThemes };
